import React, { createContext, useContext, ReactNode } from "react";

const CardPreviewContext = createContext<boolean>(false);

interface CardPreviewProviderProps {
  isPreview: boolean;
  children: ReactNode;
}

export const CardPreviewProvider: React.FC<CardPreviewProviderProps> = ({
  isPreview,
  children,
}) => (
  <CardPreviewContext.Provider value={isPreview}>
    {children}
  </CardPreviewContext.Provider>
);

export const useCardPreview = (): boolean => useContext(CardPreviewContext);

export default CardPreviewContext;
